module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1010-5489a825a0547d66cd6b073bfa471927.png";